import * as moment from "moment";

export class DateTimeUtils {

  public static calculateDurationNumber(start: Date, end: Date) {
    let time1 = new Date(start).getTime();
    let time2 = new Date(end).getTime();
    return (Math.floor((time2 - time1) / (1000 * 60)));
  }

  public static stripSeconds(date: Date) {
    const minutes = 1;
    const ms = 1000 * 60 * minutes;
    return new Date(Math.ceil(date.getTime() / ms) * ms);
  }

  public static calculateDurationMinutes(start: Date, end: Date) {
    const startTime = this.stripSeconds(start).getTime();
    const endTime = this.stripSeconds(end).getTime();
    const duration = (Math.round(endTime - startTime) / (1000 * 60));
    return this.getDurationString(duration);
  }

  // Returns the formatted duration string based on the number of minutes (67 minutes = "01:07:00")
  // Zero and negative numbers return "00:00:00"
  public static getDurationString(minutes: number) {
    if (minutes < 1) {
      return "00:00:00";
    }
    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;
    return (hours < 10 ? "0" : "") + hours.toString() + ":" + (mins < 10 ? "0" : "") + mins.toString() + ":00";
  }

  public static getTimeArrayQuarters(): string[] {
    let quarterHours = ["00", "15", "30", "45"];
    let times = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 4; j++) {
        if (i < 10) {
          times.push("0" + i + ":" + quarterHours[j]);
        } else {
          times.push(i + ":" + quarterHours[j]);
        }
      }
    }
    return times;
  }

  public static getTimeArrayQuartersFrom(): string[] {
    return this.getTimeArrayQuarters();
  }

  public static getTimeArrayQuartersTo(): string[] {
    let times = this.getTimeArrayQuarters();

    times.splice(0, 1);
    times.push("00:00");

    return times;
  }


  //Selectable timestring on format "HH:MM"
  public static convertStringToDateFrom(activeDate: string, time: string): Date {
    if (!time.includes(":")) return undefined;

    const t = moment(activeDate);

    const timePartsFrom = time.split(':');
    t.hour(+timePartsFrom[0]);
    t.minute(+timePartsFrom[1]);
    t.second(0)
    t.millisecond(0)
    return t.toDate();
  }

  public static convertStringToDateTo(activeDate: string, time: string): Date {
    if (!time.includes(":")) return undefined;


    const t = moment(activeDate);

    const timePartsFrom = time.split(':');
    t.hour(+timePartsFrom[0]);
    t.minute(+timePartsFrom[1]);
    t.second(0)
    t.millisecond(0)

    if (timePartsFrom[0] === "00" && timePartsFrom[1] === "00") {
      t.add(1, 'days');
    }

    return t.toDate();
  }
}

